import React from 'react'
import './Discover.css'

function Discover() {

  document.title = "Discover"

  return (
    <React.Fragment>

        <section className=''>

        </section>

        
    </React.Fragment>
  )
}

export default Discover